module.exports = __webpack_public_path__ + "img/cup-fill.f21e902a.svg";